import { ConfirmationVariant } from 'src/modules/confirmation/types/confirmation.types'

export const confirmationVariants: Record<ConfirmationVariant, string> = {
  accept: 'accept',
  waiting: 'waiting',
  reject: 'reject',
}
